import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Veyra',
    legalName: 'Veyra, Inc.',
    tagline: 'Smarter financial management',
    description: 'Veyra helps finance managers automate manual work, gain real-time visibility into financial performance and make faster, data-driven decisions through intelligent AI automation.',
    url: getOrigin(),
    contact: {
        email: 'hello@veyra.com',
        salesEmail: 'sales@veyra.com',
        supportEmail: 'support@veyra.com',
        location: 'San Francisco, California',
        hours: 'Monday to Friday, 8am to 6pm PT'
    },
    links: {
        linkedin: 'https://www.linkedin.com/',
        x: 'https://x.com/',
        youtube: 'https://www.youtube.com/'
    }
}
